import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductInfoSource } from "~/components/StoreInfo/types";
import { StoreInfo } from "~/components/StoreInfo/StoreInfo";
import { Reviews } from "~/components/Reviews/Reviews";
import { ReviewItem } from "~/components/Reviews/reviews.types";
import { InternalView } from "~/components/internal-view";
import styles from "./store-information.module.css";
import { camelizeKeys } from "humps";
import { getStoreInformationStats } from "~/modules/store-information/store-information.service";

export const StoreInformation = ({ partner }: {partner: any;}) => {
  const { t } = useTranslation();
  const userNetwork = partner?.userNetwork;
  const url = `/catalogo/${userNetwork?.urlSummer}/todos-los-productos`;
  const [reviews, setReviews] = useState<ReviewItem[]>([]);

  useEffect(() => {
    if (partner?.userId) {
      getStoreInformationStats(partner?.userId).
      then(async (response) => {
        return (camelizeKeys(await response.json()) as ReviewItem[]);
      }).
      then((data) => {
        setReviews(data);
      }).
      catch(() => {
        setReviews([]);
      });
    }
  }, [partner?.userId]);

  return (
    <div
      className={styles.storeInformationWrapper}
      role={"store-information-container"}>

      <InternalView
        copy={t("StoreInformation.internal_title")}
        breadcrumbs={[
        { text: t("StoreInformation.internal_breadcrumb_title") }]}>


        <div className={styles.container}>
          <div className={styles.information}>
            <div className={styles.storeInformationBox}>
              <h3 className={styles.storeInformationSectionTitle}>
                {t("StoreInformation.title")}
              </h3>
              <StoreInfo
                textButton={t("StoreInformation.see_products")}
                to={url}
                source={ProductInfoSource.StoreInfoPage}
                partner={partner?.userDetail} />

            </div>
            <div className={styles.storeInformationBox}>
              <h3 className={styles.storeInformationSectionTitle}>
                {t("reviews.title")}
              </h3>
              <Reviews
                reviews={reviews}
                source={ProductInfoSource.StoreInfoPage}
                name={partner?.enterpriseName || ""} />

            </div>
          </div>
        </div>
      </InternalView>
    </div>);

};